import { render } from "./invisionReadOnly.vue?vue&type=template&id=eb80fc76"
import script from "./invisionReadOnly.vue?vue&type=script&lang=js"
export * from "./invisionReadOnly.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__